
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
name: "RepairOrder",
components: {Tab, TabItem, Group, Cell, XButton},
data() {
return {
dataList: [],
total: 0,
header: {
headers: {
token: localStorage.getItem('token'),
opid: localStorage.getItem('userid')
}
},
type: 'accept',
isAdmin: this.$route.params.isAdmin,
typeadmin: 'assign'
}
},
methods: {
goToRepair(seq) {
this.$router.push({name: 'RepairSrvp', query: {seq, type: this.type, role: this.isAdmin ? 'ADMIN' : 'SRVP'}})
},

toAccept() {
this.type = 'accept';
this.dataList = [];
this.total = 0;
this.$http.get('api/v1/normalrepairs?account=' + localStorage.getItem('userid') + '&role=SRVP&offset=0&count=10&stage=accept&crit=' + JSON.stringify({
user: '',
device: '',
expt: '',
start: '',
end: '',
company: '',
seq:''
}), this.header).then(response => {
this.dataList = [...this.dataList, ...response.data.content].map(item => {
return this.init(item)
})
this.total = response.data.total
})
},
beingProcess() {
this.type = 'process';
this.dataList = [];
this.total = 0;
this.$http.get('api/v1/normalrepairs?account=' + localStorage.getItem('userid') + '&role=SRVP&offset=0&count=10&stage=process&crit=' + JSON.stringify({
user: '',
device: '',
expt: '',
start: '',
end: '',
company: '',
seq:''
}), this.header).then(response => {
this.dataList = [...this.dataList, ...response.data.content].map(item => {
return this.init(item)
})
this.total = response.data.total
})
},
processed() {
this.type = 'done';
this.dataList = [];
this.total = 0;
this.$http.get('api/v1/normalrepairs?account=' + localStorage.getItem('userid') + '&role=SRVP&offset=0&count=10&stage=done&crit=' + JSON.stringify({
user: '',
device: '',
expt: '',
start: '',
end: '',
company: '',
seq:''
}), this.header).then(response => {
this.dataList = [...this.dataList, ...response.data.content].map(item => {
return this.init(item)
})
this.total = response.data.total
})
},
confirmed() {
this.type = 'closed';
this.dataList = [];
this.total = 0;
this.$http.get('api/v1/normalrepairs?account=' + localStorage.getItem('userid') + '&role=SRVP&offset=0&count=10&stage=closed&crit=' + JSON.stringify({
user: '',
device: '',
expt: '',
start: '',
end: '',
company: '',
seq:''
}), this.header).then(response => {
this.dataList = [...this.dataList, ...response.data.content].map(item => {
return this.init(item)
})
this.total = response.data.total
})
},
more() {
this.$http.get('api/v1/normalrepairs?account=' + localStorage.getItem('userid') + '&role=SRVP&offset=' + this.dataList.length + '&count=10&stage=' + this.type + '&crit=' + JSON.stringify({
user: '',
device: '',
expt: '',
start: '',
end: '',
company: '',
seq:''
}), this.header).then(response => {
this.dataList = [...this.dataList, ...response.data.content].map(item => {
return this.init(item)
})
this.total = response.data.total
})
},

assignAdmin() {
this.dataList = [];
this.total = 0;
this.type = 'false';
this.typeadmin = 'assign'
this.$http.get('api/v1/normalrepairs/list_unclosed_repairs?stage=assign&offset=0&count=10', this.header).then(response => {
this.dataList = [...this.dataList, ...response.data.content].map(item => {
return this.init(item)
})
this.total = response.data.total
})
},
acceptAdmin() {
this.dataList = [];
this.total = 0;
this.type = 'false';
this.typeadmin = 'accept'
this.$http.get('api/v1/normalrepairs/list_unclosed_repairs?stage=accept&offset=0&count=10', this.header).then(response => {
this.dataList = [...this.dataList, ...response.data.content].map(item => {
return this.init(item)
})
this.total = response.data.total
})
},
processAdmin() {
this.dataList = [];
this.total = 0;
this.type = 'false';
this.typeadmin = 'process'
this.$http.get('api/v1/normalrepairs/list_unclosed_repairs?stage=process&offset=0&count=10', this.header).then(response => {
this.dataList = [...this.dataList, ...response.data.content].map(item => {
return this.init(item)
})
this.total = response.data.total
})
},
doneAdmin() {
this.dataList = [];
this.total = 0;
this.type = 'true';
this.typeadmin = 'done'
this.$http.get('api/v1/normalrepairs/list_unclosed_repairs?stage=done&offset=0&count=10', this.header).then(response => {
this.dataList = [...this.dataList, ...response.data.content].map(item => {
return this.init(item)
})
this.total = response.data.total
})
},
moreAdmin() {
this.$http.get('api/v1/normalrepairs/list_unclosed_repairs?stage=' + this.typeadmin + '&offset=' + this.dataList.length + '&count=10', this.header).then(response => {
this.dataList = [...this.dataList, ...response.data.content].map(item => {
return this.init(item)
})
this.total = response.data.total
}
)
},

init(orderDetail) {
if (this.isAdmin) {
switch (orderDetail.overall_status) {
case 'WAITPROCESS_WAITCONFIRM':
orderDetail.overall_name = '待处理';
break;
case 'WAITPROCESS_WAITCONFIRM_CANCEL':
orderDetail.overall_name = '待处理,用户已取消';
break;
case 'WAITPROCESS_CONFIRMED':
orderDetail.overall_name = '待处理,故障已确认';
break;
case 'WAITPROCESS_CONFIRMED_CANCEL':
orderDetail.overall_name = '待处理，故障已确认，用户已取消';
break;
case 'PROCESSING_WAITCONFIRM':
orderDetail.overall_name = '处理中';
break;
case 'PROCESSING_WAITCONFIRM_CANCEL':
orderDetail.overall_name = '处理中，用户已取消';
break;
case 'PROCESSING_CONFIRMED':
orderDetail.overall_name = '处理中，故障已确认';
break;
case 'PROCESSING_CONFIRMED_CANCEL':
orderDetail.overall_name = '处理中，故障已确认，用户已取消';
break;
case 'PROCESSED_CONFIRMED':
orderDetail.overall_name = '处理完成，待关闭';
break;
case 'ASSIGNED':
orderDetail.overall_name = '已指派，待接单';
break;
case 'ASSIGNED_CANCEL':
orderDetail.overall_name = '已指派，用户已取消';
break;
case 'PROCESSED_WAIT':
orderDetail.overall_name = '处理完成，等待用户确认';
break;
case 'PROCESSED_ARBIT':
orderDetail.overall_name = '处理完成，等待仲裁';
break;
default:
break;
}
} else {
switch (orderDetail.overall_status) {
case 'PROCESSING_WAITCONFIRM':
orderDetail.overall_name = '处理中';
break;
case 'PROCESSING_WAITCONFIRM_CANCEL':
orderDetail.overall_name = '处理中，用户已取消';
break;
case 'PROCESSING_CONFIRMED':
orderDetail.overall_name = '处理中，故障已确认';
break;
case 'PROCESSING_CONFIRMED_CANCEL':
orderDetail.overall_name = '处理中，故障已确认，用户已取消';
break;
case 'PROCESSED_CONFIRMED':
orderDetail.overall_name = '处理完成';
break;
case 'ASSIGNED':
orderDetail.overall_name = '待接单';
break;
case 'ASSIGNED_CANCEL':
orderDetail.overall_name = '用户已取消';
break;
default:
break;
}
}
return orderDetail
}
},
created() {
let account;
this.$http.get('/api/v1/wechat/' + localStorage.getItem('unionid')).then(res => {
res.data.forEach(item => {
if (item.role === (this.isAdmin ? 'ADMIN' : 'SRVP')) {
account = item.account;
}
});
this.$http.post('api/v1/wechat/' + localStorage.getItem('unionid') + '/token', {'account': account})
.then(response => {
localStorage.setItem('token', response.data.token);
localStorage.setItem('userid', response.data.userid);
this.header = {
headers: {
token: response.data.token,
opid: response.data.userid
}
}
this.$http.get('api/v1/accounts/' + response.data.userid, {
headers: {
token: response.data.token,
opid: response.data.userid
}
}).then(res => {
res.data.forEach(item => {
if (item.type === 'SRVP') {
if (item.tasks.indexOf('RootAdmin') !== -1 || item.tasks.indexOf('RepairAdmin') !== -1) {
this.toAccept();
}
} else if (item.type === 'ADMIN') {
if (item.tasks.indexOf('RootAdmin') !== -1 || item.tasks.indexOf('RepairAdmin') !== -1 || item.tasks.indexOf('SuperAdmin') !== -1) {
this.assignAdmin();
}
}
});
})
})
})
},
beforeRouteLeave(to, from, next) {
if (to.name === 'list') {
to.params.role = this.isAdmin ? 'ADMIN' : 'SRVP';
}
next()
}
}



// WEBPACK FOOTER //
// ./src/components/Administrator/RepairOrder.vue